import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { InvoicePaymentSearchResponse } from '../services/InvoicePaymentService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/invoices/payments'), () => {
    return HttpResponse.json<InvoicePaymentSearchResponse>({
      page: 0,
      results: [
        {
          id: '1',
          fee: '3.00',
          isDeprecated: false,
          label: 'Same Day Pay',
          paymentTermsId: '1',
          paymentMethodId: '2 ',
          isDefault: false,
        },
        {
          id: '2',
          fee: '3.00',
          isDeprecated: false,
          label: 'Net 15',
          paymentTermsId: '1',
          paymentMethodId: '2 ',
          isDefault: false,
        },
        {
          id: '3',
          fee: null,
          isDeprecated: false,
          label: 'Net 30',
          paymentTermsId: '1',
          paymentMethodId: '2 ',
          isDefault: false,
        },
      ],
      rowCount: 3,
      rows: 3,
      total: 3,
    });
  }),
];
